import { useEffect, useState } from "react";
import { FaUserCircle, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Topbar.css";

const Topbar = ({ title, onMenuClick }) => {
  const navigate = useNavigate();
  const [time, setTime] = useState("");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="menu-toggle" onClick={onMenuClick}>
          <FaBars />
        </button>
        <h2 className="topbar-title">{title}</h2>
      </div>

      <div className="topbar-right">
        <div className="time-badge">{time}</div>
        <div className="vertical-divider"></div>
        <div 
          className={`user-profile ${user.roleName === 'PARENT' ? 'non-clickable' : ''}`} 
          onClick={() => user.roleName !== 'PARENT' && navigate("/dashboard/profile")}
        >
          <div className="user-info">
            <span className="user-name">{user.userName || "Guest"}</span>
            <span className="user-role">{user.roleName || "User"}</span>
          </div>
          <div className="profile-avatar">
             <FaUserCircle />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
